export default __webpack_public_path__ + "static/media/paperReady.df14f9fb.svg";